/// <reference path="../../services/account.service.js" />
const mod = require('../../bahabot.module.js')


/**
 * @param {AccountService} AccountService
 */
function bbAccountsController(AccountService) {
    this.data = {
        users: []
    };

    this.loading = {
        users: true,

        addUser: false,
        deleteUser: false,
        editUser: false,
    };

    this.errors = {
        getUser: null,
        addUser: null,
        deleteUser: null,
        editUser: null
    };

    this.modals = {
        addUser: null, // { username: string, password: string }
        deleteUser: null, // { id: string, username: string }
        editUser: null, // { id: string, username: string, password: string }
    }

    AccountService.get()
        .then(r => {
            this.data.users = r;
        })
        .catch(e => {
            if (e.status === 401) {
                this.errors.getUser = e.data.error;
            }
        })
        .finally(() => {
            this.loading.users = false;
        });

    this.onAddUserClick = () => { 
        this.modals.addUser = {};
    }
    
    this.onAddUserSubmit = (e) => {
        this.loading.addUser = true;

        AccountService.post(this.modals.addUser)
            .then(r => {
                this.data.users.push(r);
                this.onDismissModalClick('addUser');
            })
            .catch(e => {
                this.errors.addUser = e.data.error;
            })
            .finally(() => {
                this.loading.addUser = false;
            })
    }

    this.onDeleteUserClick = (user) => {
        this.modals.deleteUser = user;
    }

    this.onDeleteUserSubmit = () => {
        this.loading.deleteUser = true;

        AccountService.delete(this.modals.deleteUser.id)
            .then(r => {
                const uRef = this.data.users.find(u => u.id === this.modals.deleteUser.id);
                const idx = this.data.users.indexOf(uRef);
                this.data.users.splice(idx, 1);
                this.onDismissModalClick('deleteUser');
            })
            .catch(e => {
                this.errors.deleteUser = e.data.error;
            })
            .finally(() => {
                this.loading.deleteUser = false;
            })
    }

    this.onEditUserClick = (user) => {
        this.modals.editUser = { ...user, password: "" };
    }

    this.onEditUserSubmit = () => {
        const user = {
            username: this.modals.editUser.username
        };

        if (this.modals.editUser.password.length) {
            user.password = this.modals.editUser.password;
        }

        this.loading.editUser = true;

        AccountService.patch(this.modals.editUser.id, user)
            .then(r => {
                const uRef = this.data.users.find(u => u.id === this.modals.editUser.id);
                uRef.username = this.modals.editUser.username;
                this.onDismissModalClick('editUser');
            })
            .catch(e => {
                this.errors.editUser = e.data.error;
            })
            .finally(() => {
                this.loading.editUser = false;
            })
    }

    this.onDismissModalClick = (modal) => {
        this.modals[modal] = null;
        this.errors[modal] = null;
    }
}

mod.component('bbAccounts', {
    templateUrl: 'tpl/bb-accounts.component.html',
    bindings: {},
    controller: ["AccountService", bbAccountsController]
});